import React from "react";
import { withPrefix } from "gatsby";
import { Helmet, HelmetProvider } from "react-helmet-async";
import useSeo from "./useSeo";

export const Seo = ({
  title,
  description,
  img,
  type = "website",
  lang,
  children,
  canonicalUrl,
  previousUrlPage,
  nextsUrlPage,
}) => {
  const { defaultImg, defaultTitle, metaDescription } = useSeo({
    description,
    title,
    img,
  });

  let titleTemplate = null;
  if (defaultTitle) {
    titleTemplate = `%s | ${defaultTitle}`;

    if (title?.includes("| Sendity")) {
      titleTemplate = `%s`;
    }
  }

  return (
    <HelmetProvider>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={title}
        titleTemplate={titleTemplate}
      >
        <meta
          name="llms-file"
          content="https://www.sendity.com/llms-full.txt"
        />
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={defaultTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:type" content={type} />
        <meta property="og:image" content={defaultImg} />
        {!!canonicalUrl?.canonical && (
          <link
            rel="canonical"
            href={`https://sendity.com${canonicalUrl.canonical}`}
          />
        )}
        {!!canonicalUrl?.en && (
          <link
            rel="alternate"
            hreflang="en"
            href={`https://sendity.com${canonicalUrl.en}`}
          />
        )}
        {!!canonicalUrl?.es && (
          <link
            rel="alternate"
            hreflang="es"
            href={`https://sendity.com${canonicalUrl.es}`}
          />
        )}
        {(!!canonicalUrl?.["x-default"] || canonicalUrl?.es) && (
          <link
            rel="alternate"
            hreflang="x-default"
            href={`https://sendity.com${
              canonicalUrl?.["x-default"] || canonicalUrl?.es
            }`}
          />
        )}
        {!!previousUrlPage && <link rel="prev" href={previousUrlPage} />}
        {!!nextsUrlPage && <link rel="next" href={nextsUrlPage} />}
        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href={withPrefix("icons/apple-icon-57x57.webp")}
        />
        <link
          rel="apple-touch-icon"
          sizes="60x60"
          href={withPrefix("icons/apple-icon-60x60.webp")}
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href={withPrefix("icons/apple-icon-72x72.webp")}
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href={withPrefix("icons/apple-icon-76x76.webp")}
        />
        <link
          rel="apple-touch-icon"
          sizes="114x114"
          href={withPrefix("icons/apple-icon-114x114.webp")}
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href={withPrefix("icons/apple-icon-120x120.webp")}
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href={withPrefix("icons/apple-icon-144x144.webp")}
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href={withPrefix("icons/apple-icon-152x152.webp")}
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={withPrefix("icons/apple-icon-180x180.webp")}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href={withPrefix("icons/android-icon-192x192.webp")}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={withPrefix("icons/favicon-32x32.webp")}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href={withPrefix("icons/favicon-96x96.webp")}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={withPrefix("icons/favicon-16x16.webp")}
        />
        <link rel="manifest" href={withPrefix("manifest.webmanifest")} />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta
          name="msapplication-TileImage"
          content={withPrefix("icons/ms-icon-144x144.webp")}
        />
        <meta name="theme-color" content="#ffffff" />
        <meta
          name={"google-site-verification"}
          description="google24ddda01438a9903"
        />
      </Helmet>
      {children}
    </HelmetProvider>
  );
};
